import { Injectable } from '@angular/core';
import { TREQUEST_UPDATE_FACTORY_UOM } from '@monorepo/types';
import { select, Store } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TREQUEST_ALLOCATE_PRODUCTS_TYPES_TO_FACTORIES } from '@monorepo/types';
import * as FactoryListActions from './factory-list.actions';
import * as FactoryListSelectors from './factory-list.selectors';

@Injectable({
  providedIn: 'root',
})
export class FactoryListFacade {
  constructor(private store: Store<TPlani8State>) {}

  fetchFactoryListInfo() {
    this.store.dispatch(new FactoryListActions.GetFactoryListInfo());
  }

  allocateProductTypesToFactories(productTypesAndFactoryIds: TREQUEST_ALLOCATE_PRODUCTS_TYPES_TO_FACTORIES) {
    this.store.dispatch(new FactoryListActions.AllocateProductTypesToFactories(productTypesAndFactoryIds));
  }

  getFactoryListInfo() {
    return this.store.pipe(select(FactoryListSelectors.getFactoryListInfo));
  }

  fetchFactoryUom(factoryId: string) {
    this.store.dispatch(new FactoryListActions.GetFactoryUom(factoryId));
  }

  getFactoryUom() {
    return this.store.pipe(select(FactoryListSelectors.getFactoryUom));
  }

  updateFactoryUom(factoryId: string, payload: TREQUEST_UPDATE_FACTORY_UOM) {
    this.store.dispatch(new FactoryListActions.UpdateFactoryUom(factoryId, payload));
  }
}

export type TGetFactoryListInfo = ReturnType<FactoryListFacade['getFactoryListInfo']>;
export type TGetFactoryUom = ReturnType<FactoryListFacade['getFactoryUom']>;
